var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.availablePlaces,"dense":"","hide-details":"","offset-y":"","label":"Game Place","outlined":""},model:{value:(_vm.place),callback:function ($$v) {_vm.place=$$v},expression:"place"}})
}
var staticRenderFns = []

export { render, staticRenderFns }